import React,{useState,useEffect} from 'react'
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { invokeSquadInfo } from '../../ServiceCalls/ApiCalls';
import { PropagateLoader } from 'react-spinners';
import './SquadInfo.css'


function SquadInfoComponent() {
    
    const navigate = useNavigate()

    const[squadInfo,setSquadInfo] = useState([])
    const[squadName,setSquadName] = useState('')
    const[squadCost,setSquadCost] = useState('')
    const[squadInfoId,setSquadInfoId] = useState('')
    const[day,setDay]=useState('')
    const[timing,setTiming] = useState('')
    const[rowid,setRowId]= useState('')
    const[status,setStatus]=useState(false)
    const[isLoading,setIsLoading]=useState(false)
    const[isRefreshing,setIsRefreshing]=useState(false)
    const[createSquadInfo,setCreateSquadInfo] = useState({
        squad_cost:'',
        squad_name:'',
        day:'',
        timing:''
    })

    useEffect(() =>{
        if(!localStorage.getItem('user')){
            navigate('/')
        }
        async function GetData(){
            setIsLoading(true)
            try {
                const squadinfo_list = await invokeSquadInfo()
                setSquadInfo(squadinfo_list)
            } catch (error) {
                console.error('Error fetching squad info:', error)
                toast.error('Failed to load squad information')
            } finally {
                setIsLoading(false)
            }
        }
    
        GetData()
    },[])
    const handleAddSquadInfo = (e) => {
        const{name,value} = e.target;
        setCreateSquadInfo({...createSquadInfo,[name]:value})
    }
    const reset = (e) => {
        e.preventDefault()
        setCreateSquadInfo({
            squad_cost:'',
            squad_name:'',
            day:'',
            timing:''
        })
    }
    
    const refreshSquadInfo = async () => {
        setIsRefreshing(true)
        try {
            const squadinfo_list = await invokeSquadInfo()
            setSquadInfo(squadinfo_list)
            toast.success('Squad information refreshed successfully!')
        } catch (error) {
            console.error('Error refreshing squad info:', error)
            toast.error('Failed to refresh squad information')
        } finally {
            setIsRefreshing(false)
        }
    }
    const options = (method = "GET",body) =>{
        return {
            method,
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }
    }
    const handleSquadInfoChange = e =>{
        const{name,value} = e.target;
        if(name === 'squad_cost'){
            setSquadCost(value)
        }
        if(name === 'squad_name'){
            setSquadName(value)
        }
        if(name === 'day'){
            setDay(value)
        }
        if(name === 'timing'){
            setTiming(value)
        }
    }
    const handleEditSquadInfo = (s,rid) => {
        setSquadName(s.squad_name)
        setSquadCost(s.squad_cost)
        setSquadInfoId(s._id)
        setDay(s.day)
        setTiming(s.timing)
        setRowId(rid)
        setStatus(false)
    }
    const handleSubmitSquadInfo = async(e) => {
        e.preventDefault()

        try {
            const add_squadinfo_response = await fetch(`${URL}` + '/squadinfo/addsquadinfo',options("POST",createSquadInfo));
            const squadinfo_data = await add_squadinfo_response.json();

            if(add_squadinfo_response.ok){
                //alert('Term Dates Added !!')
                setSquadInfo([...squadInfo,squadinfo_data])
                toast.success('🦄 Wow SquadInfo Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Add SquadInfo Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleUpdateSquadInfo = async() => {
        try {
            const update_squadinfo_response = await fetch(`${URL}` + '/squadinfo/'+`${squadInfoId}`,options("PATCH",{squad_name:squadName,squad_cost:squadCost,day,timing}));

            if(update_squadinfo_response.ok){
                const update_squadinfo_status = await update_squadinfo_response.json();
                const dataUpdate = [...squadInfo]
                dataUpdate[rowid] = update_squadinfo_status;
                setSquadInfo([...dataUpdate])
                setStatus(true)
                //toggleRow(rowid)
                toast.success('🦄 Wow SquadInfo Updated!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else{
               // alert('Update Failed')
               toast.error('🦄 OOps SquadInfo Update Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    }
    const deleteSquadInfo = async(tr_id,rowid) => {

        if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`))
            return;

        try{
            const delete_squadinfo_response = await fetch(`${URL}` + '/squadinfo/'+`${tr_id}`, options("DELETE"));
            if(delete_squadinfo_response.ok){
               // alert(`TermDate at ${rowid+1}  is Deleted !!`)
                const dataDelete = [...squadInfo];
                dataDelete.splice(rowid,1)
                setSquadInfo([...dataDelete])
                toast.success('🦄 Wow SquadInfo Deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
    
            }
            else{
                toast.error('🦄 OOps SquadInfo Del Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        }catch(err){
            console.log(err)
        }
      }
  return (
    <div className='admin-panel'>
      <div className="container admin-container">
        {/* Header Section */}
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
              <div>
                <h3 className="mb-1">
                  <i className="fa fa-info-circle text-warning me-2"></i>
                  Manage Squad Information
                </h3>
                <p className="text-muted">
                  Add and manage squad details including costs, schedules, and timings
                </p>
                <span className="badge bg-primary">
                  <i className="fa fa-users me-1"></i>
                  {squadInfo.length} {squadInfo.length === 1 ? 'Squad' : 'Squads'}
                </span>
              </div>
              <div className="header-actions">
                <button
                  onClick={refreshSquadInfo}
                  disabled={isRefreshing}
                  className="btn btn-outline-primary me-2">
                  {isRefreshing ? (
                    <PropagateLoader size={8} color="#007bff" />
                  ) : (
                    <>
                      <i className="fa fa-refresh me-2"></i>
                      Refresh
                    </>
                  )}
                </button>
                <button
                  onClick={() => navigate('/user')}
                  className="btn btn-outline-secondary">
                  <i className="fa fa-arrow-left me-2"></i>
                  Back to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="loading-container">
            <div className="loading-content">
              <PropagateLoader size={15} color="#007bff" />
              <p className="loading-text">Loading squad information...</p>
            </div>
          </div>
        ) : (
          <>
            {/* Add Squad Section */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-plus text-success me-2"></i>
                      Add New Squad Information
                    </h5>
                  </div>
                  <form onSubmit={handleSubmitSquadInfo} className="squad-form">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="squad_name" className="form-label">
                          <i className="fa fa-tag text-primary me-2"></i>
                          Squad Name
                        </label>
                        <input 
                          type="text" 
                          className="form-control" 
                          id="squad_name" 
                          name="squad_name"
                          value={createSquadInfo.squad_name}
                          onChange={e => handleAddSquadInfo(e)} 
                          required
                          placeholder="Enter Squad Name" 
                          autoComplete='off'/>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="squad_cost" className="form-label">
                          <i className="fa fa-dollar text-success me-2"></i>
                          Squad Cost
                        </label>
                        <input 
                          type="number" 
                          className="form-control" 
                          id="squad_cost" 
                          name="squad_cost"
                          value={createSquadInfo.squad_cost}
                          onChange={e => handleAddSquadInfo(e)} 
                          required
                          placeholder="Enter Squad Cost" 
                          autoComplete='off'/>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="day" className="form-label">
                          <i className="fa fa-calendar text-info me-2"></i>
                          Day
                        </label>
                        <input 
                          type="text" 
                          className="form-control" 
                          id="day" 
                          name="day"
                          value={createSquadInfo.day} 
                          onChange={e => handleAddSquadInfo(e)} 
                          required
                          placeholder="e.g., Monday, Tuesday" 
                          autoComplete='off'/>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="timing" className="form-label">
                          <i className="fa fa-clock text-warning me-2"></i>
                          Timing
                        </label>
                        <input 
                          type="text" 
                          className="form-control" 
                          id="timing" 
                          name="timing"
                          value={createSquadInfo.timing} 
                          onChange={e => handleAddSquadInfo(e)} 
                          required
                          placeholder="e.g., 6:00 PM - 8:00 PM" 
                          autoComplete='off'/>
                      </div>
                    </div>
                    <div className="form-actions">
                      <button 
                        type="submit" 
                        className="btn btn-primary me-2">
                        <i className="fa fa-plus me-2"></i>
                        Add Squad Info
                      </button>
                      <button 
                        type="button"
                        onClick={e => reset(e)}
                        className="btn btn-outline-secondary">
                        <i className="fa fa-refresh me-2"></i>
                        Reset Form
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Existing Squad Info Section */}
            <div className="row">
              <div className="col-12">
                <div className="admin-section">
                  <div className="section-header">
                    <h5 className="section-title">
                      <i className="fa fa-list text-info me-2"></i>
                      Existing Squad Information
                    </h5>
                  </div>
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th>S.No</th>
                                <th>Squad Name</th>
                                <th>Cost (AUD)</th>
                                <th>Day</th>
                                <th>Timing</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {squadInfo.length > 0 ? (
                                squadInfo.map((s,idx) => (
                                  <tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>
                                      <strong className="text-primary">{s.squad_name}</strong>
                                    </td>
                                    <td className="text-center">
                                      <span className="badge bg-success">A$ {s.squad_cost}</span>
                                    </td>
                                    <td>
                                      <i className="fa fa-calendar text-info me-1"></i>
                                      {s.day}
                                    </td>
                                    <td>
                                      <i className="fa fa-clock text-warning me-1"></i>
                                      {s.timing}
                                    </td>
                                    <td className="text-center">
                                      <div className="btn-group" role="group">
                                        <button
                                          type="button"
                                          onClick={() => handleEditSquadInfo(s,idx)}
                                          data-bs-toggle="modal"
                                          data-bs-target="#editModalPop"
                                          className="btn btn-sm btn-outline-primary"
                                          title="Edit Squad Info">
                                          <i className="fa fa-edit"></i>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => deleteSquadInfo(s._id,idx)}
                                          className="btn btn-sm btn-outline-danger"
                                          title="Delete Squad Info">
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={6} className="text-center py-4">
                                    <div className="empty-state">
                                      <i className="fa fa-users fa-3x text-muted mb-3"></i>
                                      <h5 className="text-muted">No Squad Information Found</h5>
                                      <p className="text-muted">Add your first squad information using the form above.</p>
                                    </div>
                                  </td>
                                </tr>
                              )
                            }
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Edit Modal */}
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel">Edit Squad</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        data-bs-dismiss="modal" 
                                        //onClick={() => handleReset()} 
                                        aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    {
                                        status ? 
                                            <div className="container">
                                                <div className="row my-3">
                                                    <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                                         <div className="success-img"></div>
                                                        <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="container">
                                            <div className="row my-3">
                                            <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="squad_name" className="small"><strong>SquadName</strong></label>
                                                    <input 
                                                        type="text"
                                                        className='form-control service'
                                                        name="squad_name"
                                                        value={squadName}
                                                        onChange={e => handleSquadInfoChange(e)}
                                                        autoComplete='off'
                                                        id="squad_name" />
                                                </div> 
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="squad_cost" className="small"><strong>SquadCost</strong></label>
                                                    <input 
                                                        type="text"
                                                        className='form-control service'
                                                        name="squad_cost"
                                                        value={squadCost}
                                                        onChange={e => handleSquadInfoChange(e)}
                                                        autoComplete='off'
                                                        id="squad_cost" />
                                                </div>  
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="day" className="small"><strong>Day</strong></label>
                                                    <input 
                                                        type="text"
                                                        className='form-control service'
                                                        name="day"
                                                        value={day}
                                                        onChange={e => handleSquadInfoChange(e)}
                                                        autoComplete='off'
                                                        id="day" />
                                                </div>  
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="timing" className="small"><strong>Timing</strong></label>
                                                    <input
                                                        name="timing"
                                                        className='form-control service'
                                                        id="timing"
                                                        value={timing}
                                                        autoComplete='off'
                                                        onChange = {e => handleSquadInfoChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                   
                                </div>
                                <div className="modal-footer">
                                    {/* <button 
                                        type="button" 
                                        className="btn btn-secondary"
                                        onClick={() => handleReset()} 
                                        data-bs-dismiss="modal">Close</button> */}
                                    {
                                        status ? 
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            //onClick={() => handleReset()} 
                                            data-bs-dismiss="modal">Close</button>
                                        :
                                        <button 
                                            onClick={() => handleUpdateSquadInfo()}
                                            type="button" 
                                            className="btn btn-primary">Update</button>
                                    }
                                    
                                </div>
                            </div>
                        </div>
             
                </div>
      </div>
      <ToastContainer/>
    </div>
  )
}

export default SquadInfoComponent